import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ContactPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 5000);
    }, 1500);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#202835] shadow-lg' : 'bg-[#202835]'}`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            <Link className="flex items-center" to="/">
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-8">
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/">
                الرئيسية
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/about">
                من نحن
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/services">
                الخدمات
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/projects">
                المشاريع
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/news">
                الأخبار
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </nav>

            <Link className="hidden lg:block px-8 py-3 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer text-[#d4af37]" to="/contact">
              تواصل معنا
            </Link>

            <button 
              className="lg:hidden text-white text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#202835] border-t border-white/10">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4">
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/">الرئيسية</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link>
              <Link className="text-white font-semibold text-[#d4af37] transition-colors" to="/contact">تواصل معنا</Link>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative h-[60vh] w-full overflow-hidden mt-24">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt="تواصل معنا - شركة الهمة الذهبية" 
            className="w-full h-full object-cover object-center" 
            src="https://public.readdy.ai/ai/img_res/410fbda69fb2a7ba0b6b04aec630a999.jpg"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/80 via-[#202835]/70 to-[#202835]/80"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">تواصل معنا</h1>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto mb-6"></div>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              نحن هنا للإجابة على استفساراتكم وتلبية احتياجاتكم
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <div>
              <h2 className="text-4xl font-bold text-[#202835] mb-8">معلومات التواصل</h2>
              <p className="text-lg text-[#202835]/80 leading-relaxed mb-12">
                يسعدنا تواصلكم معنا في أي وقت. فريقنا جاهز للرد على استفساراتكم وتقديم الدعم اللازم.
              </p>

              <div className="space-y-8">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-3xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#202835] mb-3">الهاتف</h3>
                    <div className="space-y-2">
                      <p className="text-lg text-[#202835]/80" dir="ltr">+966 50 016 5920</p>
                      <p className="text-lg text-[#202835]/80" dir="ltr">+966 50 125 5250</p>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-3xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#202835] mb-3">البريد الإلكتروني</h3>
                    <p className="text-lg text-[#202835]/80">info@gmcc.com.sa</p>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-3xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#202835] mb-3">الموقع</h3>
                    <p className="text-lg text-[#202835]/80">المملكة العربية السعودية</p>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-3xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#202835] mb-3">ساعات العمل</h3>
                    <p className="text-lg text-[#202835]/80">السبت - الخميس: 8:00 ص - 5:00 م</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-[#faf8f3] rounded-2xl p-10">
              <h2 className="text-3xl font-bold text-[#202835] mb-8">أرسل لنا رسالة</h2>
              
              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-[#202835] font-semibold mb-2" htmlFor="name">
                    الاسم الكامل
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-[#202835]/20 rounded-lg focus:outline-none focus:border-[#d4af37] transition-colors"
                    placeholder="أدخل اسمك الكامل"
                  />
                </div>

                <div>
                  <label className="block text-[#202835] font-semibold mb-2" htmlFor="email">
                    البريد الإلكتروني
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-[#202835]/20 rounded-lg focus:outline-none focus:border-[#d4af37] transition-colors"
                    placeholder="أدخل بريدك الإلكتروني"
                  />
                </div>

                <div>
                  <label className="block text-[#202835] font-semibold mb-2" htmlFor="phone">
                    رقم الهاتف
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-[#202835]/20 rounded-lg focus:outline-none focus:border-[#d4af37] transition-colors"
                    placeholder="أدخل رقم هاتفك"
                  />
                </div>

                <div>
                  <label className="block text-[#202835] font-semibold mb-2" htmlFor="subject">
                    الموضوع
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-[#202835]/20 rounded-lg focus:outline-none focus:border-[#d4af37] transition-colors"
                    placeholder="موضوع الرسالة"
                  />
                </div>

                <div>
                  <label className="block text-[#202835] font-semibold mb-2" htmlFor="message">
                    الرسالة
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-3 bg-white border border-[#202835]/20 rounded-lg focus:outline-none focus:border-[#d4af37] transition-colors resize-none"
                    placeholder="اكتب رسالتك هنا (حد أقصى 500 حرف)"
                  ></textarea>
                  <p className="text-sm text-[#202835]/60 mt-2">
                    {formData.message.length}/500 حرف
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full px-8 py-4 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-[#202835] text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <Link className="inline-block mb-6" to="/">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="h-16 w-auto" 
                  src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
                />
              </Link>
              <p className="text-white/80 leading-relaxed mb-6">
                شركة الهمة الذهبية، شريكك الموثوق في عالم المقاولات والإنشاءات.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">روابط سريعة</h3>
              <ul className="space-y-3">
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">خدماتنا</h3>
              <ul className="space-y-3">
                <li className="text-white/80">الإنشاءات والبناء</li>
                <li className="text-white/80">الترميم والصيانة</li>
                <li className="text-white/80">الأعمال الكهربائية</li>
                <li className="text-white/80">أنظمة السلامة</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">تواصل معنا</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-phone-line text-[#d4af37] text-xl mt-1"></i>
                  <div>
                    <div dir="ltr">+966 50 016 5920</div>
                    <div dir="ltr">+966 50 125 5250</div>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-mail-line text-[#d4af37] text-xl mt-1"></i>
                  <span>info@gmcc.com.sa</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-6">
            <p className="text-white/60 text-sm text-center">
              © 2024 شركة الهمة الذهبية. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
